import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';

/**
 * Creates an external URL with the current app domain
 */
export const createExternalUrl = (path = '', query) => {
  const {
    protocol,
    hostname
  } = new URL(getFullUrl('app'));
  const url = new URL(path, `${protocol}//${hostname}`);
  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });
  }
  return url.toString();
};

/**
 * Navigates to the specified URL
 */
export const navigateTo = url => {
  window.location.href = url;
};

/**
 * Handles redirect with optional delay
 */
export const handleRedirect = (url, delay = 200) => {
  setTimeout(() => {
    navigateTo(url);
  }, delay);
};

/**
 * Gets the URL for viewing an active quote
 */
export const getActiveQuoteUrl = activeQuotePublicId => createExternalUrl(`/quote-checkout/${PortalIdParser.get()}/quotes/${activeQuotePublicId}`);

/**
 * Gets the URL for HSFS purchase completion
 */
export const getHSFSPurchaseUrl = () => createExternalUrl(`/hsfx-programs/${PortalIdParser.get()}/application/finish`);